import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from "ngx-uploader";

import { UploadDirectory, FileType } from './enumeration';

import { DomSanitizer } from '@angular/platform-browser';
import { EventEmitter, Input, Output } from "@angular/core";
import { FichierJoint } from "../../app/classes/fichiersJoint"
import { Statique } from "./statique";
import { INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS } from "@angular/platform-browser-dynamic/src/platform_providers";

// import { TOKEN_NAME } from "../../services/auth.constant";

export class MultiUploadComponent {

    imageToShow: any;
    formData: FormData = { concurrency: 1, autoUpload: false, verbose: true };
    files: Array<Array<UploadFile>> = new Array<Array<UploadFile>>();
    filesReturn: Array<Array<FichierJoint>> = new Array<Array<FichierJoint>>();
    uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
    humanizeBytes: Function;
    dragOver: boolean;
    componentObject: any;
    UploadDirectory = UploadDirectory;
    isGallery: Boolean = null;
    isUpdate: Boolean = null;
    fileType: number;
    isFileNotToUpload: Boolean = null;

    constructor(protected sanitizer?: DomSanitizer) {

        this.initFilesReturn();

        this.isFileNotToUpload = false;

    }

    initFilesReturn() {
        this.files[FileType.INVOICE] = new Array<UploadFile>();
        this.files[FileType.LISTE_COLISAGE] = new Array<UploadFile>();
        this.files[FileType.DOUANE] = new Array<UploadFile>();
        this.files[FileType.TRANSPORT_DOCUMENT] = new Array<UploadFile>();
        this.files[FileType.OTHER] = new Array<UploadFile>();
        this.files[FileType.POD] = new Array<UploadFile>();

        this.filesReturn[FileType.INVOICE] = new Array<FichierJoint>();
        this.filesReturn[FileType.LISTE_COLISAGE] = new Array<FichierJoint>();
        this.filesReturn[FileType.DOUANE] = new Array<FichierJoint>();
        this.filesReturn[FileType.TRANSPORT_DOCUMENT] = new Array<FichierJoint>();
        this.filesReturn[FileType.OTHER] = new Array<FichierJoint>();
        this.filesReturn[FileType.POD] = new Array<FichierJoint>();
    }

    onUploadOutput(output: UploadOutput): void {

        let fileType = this.files[this.fileType];

        if ((output.file != null && output.file != undefined) && output.file.size > Statique.$5MbToBytes && !this.isFileNotToUpload) {
            this.componentObject.fileMaxSizeError();
            this.isFileNotToUpload = true;
            output.file.nativeFile = null;
            return;
        }
        else {
            if ((output.file != null && output.file != undefined) && output.file.size <= Statique.$5MbToBytes) {
                this.isFileNotToUpload = false;
            }

            if (output.type === 'allAddedToQueue') {
                this.allAddedToQueue();
                if (this.isFileNotToUpload) {
                    this.isFileNotToUpload = false;
                }
            } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
                this.addedToQueue(output);
            } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
                const index = fileType.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
                fileType[index] = output.file;
            } else if (output.type === 'done') {
                // debugger
                // fileType.forEach(file => {
                //     if (file.response !== undefined) {
                //         this.filesReturn[this.fileType] = [...this.filesReturn[this.fileType], file.response[0]];
                //         this.files[this.fileType] = new Array<UploadFile>();
                //         if (this.componentObject.dataUpload.typeFile == this.UploadDirectory.COTATION_DOCS) {
                //             this.componentObject.listEbDemandeFichierJointNum.push(file.response[0].ebDemandeFichierJointNum)
                //         }
                //         else localStorage.setItem("filesReturn", JSON.stringify(this.filesReturn));

                //         this.onUploadComplete(file);
                //     }
                // });


            } else if (output.type === 'removed') {
                fileType = fileType.filter((file: UploadFile) => file !== output.file);
            } else if (output.type === 'dragOver') {
                this.dragOver = true;
            } else if (output.type === 'dragOut') {
                this.dragOver = false;
            } else if (output.type === 'drop') {
                this.dragOver = false;
            }
            else if (output.type === 'start') {
                if (this.files[this.fileType].length == output.file.fileIndex + 1) {
                    let interval = setInterval(() => {    //<<<---    using ()=> syntax
                        if (this.files[this.fileType].length == 0) {
                            this.componentObject.uploadEnCours = false;
                            clearInterval(interval);
                        }
                        this.files[this.fileType].forEach((file, index) => {
                            if (file.responseStatus != undefined && file.responseStatus == 200) {
                                if (file.response != null) {
                                    let response = file.response[0];
                                    this.filesReturn[this.fileType] = [...this.filesReturn[this.fileType], response];
                                    if (this.componentObject.dataUpload.typeFile == this.UploadDirectory.COTATION_DOCS) {
                                        this.componentObject.listEbDemandeFichierJointNum.push(response.ebDemandeFichierJointNum)
                                    }
                                    else localStorage.setItem("filesReturn", JSON.stringify(this.filesReturn));

                                    this.files[this.fileType].splice(index, 1)
                                }
                                else if (file.response == null && this.files[this.fileType].length != 0) {
                                    output.type = 'start'
                                    this.onUploadOutput(output)
                                }
                            }
                            else if (file.responseStatus != undefined && file.responseStatus != 200) {
                                this.files[this.fileType].splice(index, 1)
                            }
                            else {
                                output.type = 'start'
                                this.onUploadOutput(output)
                            }
                        });

                    }, 1000);
                }
            }
        }


    }

    onUploadComplete(file: UploadFile) {
    }

    allAddedToQueue() {

        this.componentObject.dataUpload.fileTypeDemande = this.fileType;

        const event: UploadInput = {
            type: 'uploadAll',
            url: "/api/upload/upload-file-demande",
            method: 'POST',
            data: this.componentObject.dataUpload,
            // concurrency: this.formData.concurrency,
            //  headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
        };
        this.uploadInput.emit(event);
    }

    addedToQueue(output: UploadOutput) {
        let fileType = this.files[this.fileType];
        fileType.push(output.file);
    }

    cancelUpload(id: string): void {
        this.uploadInput.emit({ type: 'cancel', id: id });
    }

    removeFile(id: string): void {
        this.uploadInput.emit({ type: 'remove', id: id });
    }

    removeAllFiles(): void {
        this.uploadInput.emit({ type: 'removeAll' });
    }

}

interface FormData {
    concurrency: number;
    autoUpload: boolean;
    verbose: boolean;
}


// WEBPACK FOOTER //
// ./src/app/utils/multiUploadComponent.ts